const classAdd = (node: HTMLElement, modifier: string) => {
  node.classList.add(modifier)
}

const select = (node: HTMLElement, _modifier: string) => {
  node.setAttribute('selected', 'true')
}

const addChecked = (node: HTMLElement, _modifier: string) => {
  node.setAttribute('checked', 'true')
}

const checkLogicResponses = (
  comparatorArray: string[],
  valueArray: string[],
  comparandArray: string[],
): boolean => {
  let comparandValue = 0
  let valueValue = 0

  const resultsArray = comparatorArray.map((_value, idx) => {
    const comparator = comparatorArray[idx]
    const comparand = comparandArray[idx]
    const value = valueArray[idx]
    switch (comparator) {
      // cases are all written as functions to avoid duplicate block scoped variables like "comparandValue".
      // It's kind of gross to read, but the maintainability will be easier.
      case 'eq':
        if (comparand.toLowerCase() === value.toLowerCase()) {
          return true
        }
        break
      case 'nq':
        if (comparand.toLowerCase() !== value.toLowerCase()) {
          return true
        }
        break
      case 'lt': // comparand is less than value
        comparandValue = parseInt(comparand.replace('$', '').replace(',', ''))
        valueValue = parseInt(value.replace('$', '').replace(',', ''))
        if (isNaN(comparandValue) || isNaN(valueValue)) {
          console.warn(
            `lt - attempt to cast values : ${comparand}, ${value} to numbers, returned NaN `,
          )
          return false
        }

        if (comparandValue < valueValue) {
          return true
        }
        break
      case 'lte': //comparand is less than or equal to value
        comparandValue = parseInt(comparand.replace('$', '').replace(',', ''))
        valueValue = parseInt(value.replace('$', '').replace(',', ''))
        if (isNaN(comparandValue) || isNaN(valueValue)) {
          console.warn(
            `lte - attempt to cast values : ${comparand}, ${value} to numbers, returned NaN `,
          )
          return false
        }

        if (comparandValue <= valueValue) {
          return true
        }
        break
      case 'gt': //comparand is greater than value
        comparandValue = parseInt(comparand.replace('$', '').replace(',', ''))
        valueValue = parseInt(value.replace('$', '').replace(',', ''))
        if (isNaN(comparandValue) || isNaN(valueValue)) {
          console.warn(
            `gt - attempt to cast values : ${comparand}, ${value} to numbers, returned NaN `,
          )
          return false
        }

        if (comparandValue > valueValue) {
          return true
        }
        break
      case 'gte': //comparand is greater than or equal to value
        comparandValue = parseInt(comparand.replace('$', '').replace(',', ''))
        valueValue = parseInt(value.replace('$', '').replace(',', ''))
        if (isNaN(comparandValue) || isNaN(valueValue)) {
          console.warn(
            `gte - attempt to cast values : ${comparand}, ${value} to numbers, returned NaN `,
          )
          return false
        }

        if (comparandValue >= valueValue) {
          return true
        }
        break
    }
    return false
  })

  return resultsArray.every((result) => result)
}

/**
 * TODO: Rewrite so the attributes are space separated lists instead of using number versions
 * @param root : HTMLElement
 */
export default function handleValueLogic(root: HTMLElement) {
  const logicRequiredElements = Array.from(root.querySelectorAll('[logic]'))

  logicRequiredElements.forEach((lre) => {
    const comparator = lre.getAttribute('comparator') || ''
    const comparand = lre.getAttribute('comparand') || ''
    const value = lre.getAttribute('value') || ''

    const comparatorArray = comparator.split(' ')
    const comparandArray = comparand?.split(' ')
    const valueArray = value?.split(' ')
    const ifTrue = lre.getAttribute('iftrue')

    if (
      comparatorArray.length !== comparandArray.length ||
      comparatorArray.length !== valueArray.length
    ) {
      console.warn(
        `Incorrectly formed complex logic element. \n 
           You should use the form attribute="value1 value2"
           Check for spacing issues on comparator, comparand and value properties
           Check for comparator "${comparatorArray}" support for all comparators \n 
           Check for value "${valueArray}" \n 
           Check for value "${comparandArray}"\n
           Check for array size mismatches ComparandArray = ${comparandArray.length}, \
comparatorArray = ${comparatorArray.length}, \
value array = ${valueArray.length}
           `,
      )
      return false
    }

    const modifierMap: Record<
      string,
      (_node: HTMLElement, _modifier: string) => void
    > = {
      classAdd,
      select,
      addChecked,
    }

    if (
      comparator &&
      comparand &&
      value &&
      ifTrue &&
      checkLogicResponses(comparatorArray, valueArray, comparandArray)
    ) {
      // we have all the parts of the logic gate - comparator, comparand, value and iftrue
      const functionToCall = /(^([A-z]*))\(/.exec(ifTrue)

      const modifierValue = /\('([A-z-]*)'\)/.exec(ifTrue)

      if (
        !functionToCall ||
        !modifierValue ||
        typeof modifierMap[functionToCall[1]] != 'function'
      ) {
        // gotta make sure we have both parts for the logic.
        console.warn(
          `Incorrectly formed logic element. \n 
           Check for comparator "${comparator}" support \n 
           Check for value "${value}" being wrapped in quotes and brackets  \n 
           Check for value "${comparand}" being wrapped in quotes \n
           Verify that iftrue function "${functionToCall ? functionToCall[1] : ''}" exists in source `,
        )
        return
      }

      modifierMap[functionToCall[1]](lre as HTMLElement, modifierValue[1])
    }
  })
}
